import { i18n } from "../../../setup/i18n-setup";

export default {
  pages: {
    key: "title",
    data: [
      {
        title: i18n.t('sections.home.title'),
        url: '/',
        icon: 'HomeIcon', is_bookmarked: false
      },
      {
        title: `${i18n.t('sections.courses.nav')} > ${i18n.t('sections.courses.course-outline.nav')}`,
        url: '/courses/course-outline',
        icon: 'VideoIcon', is_bookmarked: false
      },
      {
        title: `${i18n.t('sections.examination.nav')} > ${i18n.t('sections.examination.exam-upload.nav')}`,
        url: '/examination/exam-upload',
        icon: 'BookIcon', is_bookmarked: false
      },
      {
        title: `${i18n.t('sections.pm.title')}`,
        url: '/pm',
        icon: 'MailIcon', is_bookmarked: false
      },
      {
        title: `${i18n.t('profile.profile-info.title')}`,
        url: '/profile',
        icon: 'UserIcon', is_bookmarked: false
      },
    ]
  }
}
